__turbopack_context__.v({
  "body": "simple-secure-frictionless-module__fqeXUW__body",
  "card": "simple-secure-frictionless-module__fqeXUW__card",
  "cardBody": "simple-secure-frictionless-module__fqeXUW__cardBody",
  "cardTitle": "simple-secure-frictionless-module__fqeXUW__cardTitle",
  "cardTitleCyan": "simple-secure-frictionless-module__fqeXUW__cardTitleCyan",
  "cardTitleNavy": "simple-secure-frictionless-module__fqeXUW__cardTitleNavy",
  "cards": "simple-secure-frictionless-module__fqeXUW__cards",
  "emphasis": "simple-secure-frictionless-module__fqeXUW__emphasis",
  "inner": "simple-secure-frictionless-module__fqeXUW__inner",
  "pill": "simple-secure-frictionless-module__fqeXUW__pill",
  "pillCheck": "simple-secure-frictionless-module__fqeXUW__pillCheck",
  "pillCircle": "simple-secure-frictionless-module__fqeXUW__pillCircle",
  "pillIcon": "simple-secure-frictionless-module__fqeXUW__pillIcon",
  "pillLabel": "simple-secure-frictionless-module__fqeXUW__pillLabel",
  "pills": "simple-secure-frictionless-module__fqeXUW__pills",
  "section": "simple-secure-frictionless-module__fqeXUW__section",
  "tagline": "simple-secure-frictionless-module__fqeXUW__tagline",
  "title": "simple-secure-frictionless-module__fqeXUW__title",
});
